<template>
  <div :class="checkWidth() + ' ' + 'container'">
    <template v-if="loading">
      <div class="container vertical-center">
        <LoadingMDL />
      </div>
    </template>
    <template v-else>
      <CRow alignHorizontal="center" alignVertical="center">
        <CCol col="1">
          <CRow alignHorizontal="end">
            <div class="containerIconLeft" @click="linkBackTo(content)">
              <font-awesome-icon icon="chevron-left" class="IconLeft" />
            </div>
          </CRow>
        </CCol>
        <CCol col="10">
          <CRow>
            <CCol col="12">
              <CardAudio :cardContent="content" />
            </CCol>
          </CRow>
        </CCol>
        <CCol col="1">
          <div class="containerIconRight" @click="linkNextTo(content)">
            <font-awesome-icon icon="chevron-right" class="IconRight" />
          </div>
        </CCol>
      </CRow>
    </template>
  </div>
</template>
<script>
import CardAudio from './components/CardAudio.vue';
import '../../../assets/scss/_chineseStyle.scss';
import {mapGetters} from 'vuex';
import LoadingMDL from '../../../components/loading/LoadingMDL';

export default {
  components: {CardAudio, LoadingMDL},
  name: 'CTA02',
  data() {
    return {
      content: {},
      lang: this.$store.getters['language/getLanguage'],
      pageCode: '',
      baseURL: 'CTA0-',
      isModalVisible: false,
      popupData: {},
      cardType: 'img',
      isChange: false,
      newPath: '',
      CheckWidth: window.innerWidth.toString(),
      courseCode: '',
      topicId: '',
      loaded: false,
      userTemplateData: [],
      nextAction: [],
      handler: '',
      isCompletedLoad: false,
      courseSection: '',
      startTime: '',
      condition: [],
      loading: true,
      v3Data: {},
    };
  },

  computed: {
    ...mapGetters({
      // allCourse: 'template/getTemplateContent',
      storeLanguage: 'language/getLanguage',
      popUp: 'template/getPopupData',
      courseTopicID: 'courses/getCourseTopicID',
      // getUserTemplate: 'template/getUserTemplate',
      // loadingGetter: 'template/loadingGetter',
      getTemplatev3: 'v3/getTemplates',
    }),
  },

  watch: {
    getTemplatev3: function (val) {
      if (!val) return;

      this.v3Data = val;
      this.content = val.templates[0];

      if (!this.content.enable) {
        const pathFormat = this.content.navigate.close.action.split('-');
        alert('Access denied!');
        this.$router.push(`/v3/${pathFormat[0]}/${pathFormat[1]}`);
      }
      // this.$store.dispatch('v3/v3FilterParent', val.codeItem);

      this.loading = false;
    },

    storeLanguage: function (val) {
      this.lang = val;
    },
    popUp: function (val) {
      this.popupData = val;
      this.isModalVisible = true;
    },
    isChange: function () {
      this.isModalVisible = false;
      let body = {};
      body.code = this.courseCode;
      if (this.$route.params.id == undefined) {
        body.templateCode =
          `CTA02-` + this.$store.getters['necessary/getCodePage'];
      } else {
        body.templateCode = `CTA02-` + this.$route.params.id;
      }
      this.$store.dispatch('template/fetchContent', body);
    },
    '$route.params.id'() {
      //use to watch param id if changes
      //clear old state and Load new data
      this.onLoad();
    },
  },

  mounted() {},

  created() {
    this.onLoad();
  },

  beforeDestroy() {},
  methods: {
    onLoad() {
      this.courseCode = this.$store.state.necessary.learningCourse;
      this.lang = this.$store.state.language.language;
      this.startTime = this.$helpers.getDateFormat();
      //

      const contentId = `CTA02-${this.$route.params.id}`;
      this.$store.dispatch('v3/fetchTemplateByCode', contentId);
    },
    checkWidth() {
      if (this.CheckWidth > 800) {
        return 'container-chinese-card';
      } else if (this.CheckWidth <= 800) {
        return 'container-chinese-card-mobile';
      }
    },
    checkLangClass() {
      if (this.lang == 'CN') {
        return 'fontChinese';
      } else if (this.lang == 'PIN IN') {
        return 'fontPinin';
      } else {
        return '';
      }
    },
    returnData(str) {
      this.isChange = true;
      this.newPath = str[0] + '-' + str[1];
    },
    linkNextTo(path) {
      this.loading = true;
      // let str = path.navigate.next.action.split('-');
      // this.$store.commit('necessary/setCodePage', str[1]);
      // let pathTo = '/' + str[0] + '/' + str[1];
      // const useTime = this.$helpers.getUseTime();
      // this.nextAction = pathTo;
      // this.handler = str[0];
      // this.$store.dispatch('template/saveUserTemplateData', {
      //   code: this.courseCode,
      //   template: this.content._id,
      //   section: this.courseSection,
      //   startTime: this.startTime,
      //   endTime: this.$helpers.getDateFormat(),
      //   condition: this.condition,
      // });

      //stamp data
      const data = [
        {
          codeItem: this.v3Data.codeItem,
          courseId: this.$store.state.necessary.learningCourse,
          template: this.v3Data.templateID,
          section: this.$store.state.v3.v3EnrollData.data.section,
          content: this.v3Data.content,
          type: this.v3Data.type,
          answering: [],
          progress: 100,
          score: 0,
          maxScore: 0,
        },
      ];
      //dispatch
      this.$store.dispatch('v3/saveContent', data);

      const action = path.navigate.next.action;

      const next = action.split('-');
      const nextPath = `/v3/${next[0]}/${next[1]}`;

      console.log(nextPath);

      this.$router.push(nextPath);
    },
    linkBackTo(path) {
      // let str = path.navigate.previous.action.split('-');
      // this.$store.commit('necessary/setCodePage', str[1]);
      // let pathTo = '/' + str[0] + '/' + str[1];
      // if (str[0] == 'HP03') {
      //   this.$router.push(pathTo);
      // }
      // let body = {};
      // body.code = this.courseCode;
      // body.templateCode = path.navigate.previous.action;
      // this.$store.dispatch('template/fetchContent', body);
      const action = path.navigate.previous.action;

      const previous = action.split('-');
      const previousPath = `/v3/${previous[0]}/${previous[1]}`;

      this.$router.push(previousPath);
    },
    checkLanguage(val) {
      if (val) {
        for (let i = 0; i <= val.length; i++) {
          if (val[i].key == this.lang) {
            return val[i].value;
          }
        }
      } else {
      }
    },
  },
};
</script>
<style></style>
